import React, { ComponentProps } from 'react';

import ProjectPageLayout from '@adsk/alloy-project-page-layout';
import { PRODUCT_IDS, TOOL_IDS } from '@adsk/alloy-provider';
import SideNavigation from '@adsk/alloy-side-navigation';

import { LAYOUTS, Route } from './types';
import RemoteSideNavigation from '../components/RemoteSideNavigation/RemoteSideNavigation';

export default [
  {
    path: '/build/demo-app/*',
    scope: 'accDemoApp',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: 'demo-app',
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/projects',
    scope: 'accProjectList',
    modulePath: './ProjectList',
    layout: LAYOUTS.PROJECT_DIRECTORY_LAYOUT,
  },
  {
    path: '/build/bridge/accept/:inviteId',
    scope: 'accBridge',
    modulePath: './AppAcceptInviteModal',
    layout: LAYOUTS.PUBLIC_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/build/bridge/projects/:projectId/*',
    scope: 'accBridge',
    modulePath: './AppBridge',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.BRIDGE,
      currentProductId: PRODUCT_IDS.BUILD,
      variant: 'project',
      isUsersConstructionApi: true,
    },
  },
  {
    path: '/docs/bridge/projects/:projectId/*',
    scope: 'accBridge',
    modulePath: './AppBridge',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.BRIDGE,
      currentProductId: PRODUCT_IDS.DOCS,
      variant: 'project',
      isUsersConstructionApi: true,
    },
  },
  {
    path: '/dc/bridge/projects/:projectId/*',
    scope: 'accBridge',
    modulePath: './AppBridge',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.BRIDGE,
      currentProductId: PRODUCT_IDS.DESIGN_COLLABORATION,
      variant: 'project',
      isUsersConstructionApi: true,
    },
  },
  {
    path: '/project-admin/bridge/projects/:projectId/*',
    scope: 'accBridge',
    modulePath: './AppBridge',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.BRIDGE,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
      variant: 'project',
      isUsersConstructionApi: true,
    },
  },
  {
    path: '/account-admin/components/accounts/:accountId/*',
    scope: 'accLibrary',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.ACCOUNT_ADMINISTRATION,
      variant: ProjectPageLayout.VARIANTS.ACCOUNT,
      isUsersConstructionApi: true,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => {
        return (
          <RemoteSideNavigation
            scope="accAdminClient"
            module="./AccountSideNavigation"
            {...props}
          />
        );
      },
    },
  },
  {
    path: '/account-admin/templates/accounts/:accountId/*',
    scope: 'accTemplateAdmin',
    modulePath: './TemplateAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.ACCOUNT_ADMINISTRATION,
      variant: ProjectPageLayout.VARIANTS.ACCOUNT,
      isUsersConstructionApi: true,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => {
        return (
          <RemoteSideNavigation
            scope="accAdminClient"
            module="./AccountSideNavigation"
            {...props}
          />
        );
      },
    },
  },
  {
    path: '/project-admin/template-settings/projects/*',
    scope: 'accTemplateSettings',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => {
        return (
          <RemoteSideNavigation
            scope="accTemplateSettings"
            module="./ProjectAdminTemplateSideNavigation"
            {...props}
          />
        );
      },
    },
  },
  {
    path: '/build/template-settings/projects/*',
    scope: 'accTemplateSettings',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/cost/template-settings/projects/*',
    scope: 'accTemplateSettings',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.COST,
    },
  },
  {
    path: '/dc/template-settings/projects/*',
    scope: 'accTemplateSettings',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.DESIGN_COLLABORATION,
    },
  },
  {
    path: '/docs/template-settings/projects/*',
    scope: 'accTemplateSettings',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/takeoff/template-settings/projects/*',
    scope: 'accTemplateSettings',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.TAKEOFF,
    },
  },
  {
    path: '/project-admin/template-members/projects/*',
    scope: 'accTemplateSettings',
    modulePath: './TemplateMembers',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => {
        return (
          <RemoteSideNavigation
            scope="accTemplateSettings"
            module="./ProjectAdminTemplateSideNavigation"
            {...props}
          />
        );
      },
    },
  },
] satisfies Route[];
